import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';

const moment = require('moment');

const styles = theme => ({
    tableRow:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        '&:nth-of-type(2n)':{
            backgroundColor:'#f6f6f6'
        },
        '& td':{
            padding:7,
        },
        '&:first-of-type':{
            borderTop:0,
        },
    },
    tableHead:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        backgroundColor:'#6e6e6e',
        color:'white'
    },
    accountDetails:{
        width:'300px',
        position:'absolute',
        display:'none',
        border:'2px solid #6e6e6e',
        backgroundColor:'white',
        top:0,
        right:50,
        zIndex:1000,
    },
    bankDetails:{
        '&:hover .details_drawer':{
            display:'block'
        }
    }
});

class KYCDoc extends Component {
    state={
        extension:''
    }
    componentDidMount() {
        //var d = Date.parse(this.props.data._creationdate);
        //var m = moment(d);

        let extension = (/[.]/.exec(this.props.data._orig_filename)) ? /[^.]+$/.exec(this.props.data._orig_filename) : [null];

        //this.photograph = IMAGE_URL + '/user_data/' +  m.utc().format('YYYY').toString() +'/' +  m.utc().format('MM').toString() +'/' +  m.utc().format('DD').toString() + '/investor/' + Utils.md5(m.utc().format('YYYY-MM-DD').toString() + '_' + this.props.data._orig_filename) +'.'+ extension;
        this.photograph = this.props.data._orig_filename;
        this.setState({
            extension: extension
        })
    }

    render() {
        return (
            <div style={{marginBottom:10}}>
                {(this.state.extension[0] === 'pdf' || this.state.extension[0]  === 'PDF') &&
                    <iframe src={this.photograph} title={this.photograph} width={'100%'} height={'600px'} />
                }
                {(this.state.extension[0]  !== 'pdf' && this.state.extension[0]  !== 'PDF') &&
                    <img src={this.photograph} alt={'kyc'}/>
                }
                <div>{moment(this.props.data._timestamp).format('L')}
                    {(this.props.display_status !== false) &&
                        <span>- {this.props.data._new_status}</span>
                    }
                </div>
            </div>
        )
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(KYCDoc)));
